export default {
  GET_ALL_JOBS: 'getAllJobs',
  GET_JOB: 'getJob',
  SEARCH_JOB: 'searchJob',
  MOVE_TO_POOL: 'moveToPool',
  CHANGE_SLOT: 'changeSlot',
  DELETE_JOB: 'deleteJob',
  CREATE_SUBTASK: 'createSubtask',
  FINISH_SUBTASK: 'finishSubtask',
  FINISH_JOB: 'finishJob',
  REOPEN_JOB: 'reopenJob',
  GET_ALL_JOB_DEFINITIONS: 'getAllJobDefinitions',
  GET_JOB_DEFINITION: 'getJobDefinition',
  CREATE_JOB_DEFINITION: 'createJobDefinition',
  UPDATE_JOB_DEFINITION: 'updateJobDefinition',
  DELETE_JOB_DEFINITION: 'deleteJobDefinition',
  GET_ALL_POOLS: 'getAllPools',
  GET_ALL_STATUSES: 'getAllStatuses',
  GET_ALL_JOB_POOL_STATUSES: 'getAllJobPoolStatuses',
  CREATE_JOB_POOL_STATUS: 'createJobPoolStatus',
  UPDATE_JOB_POOL_STATUS: 'updateJobPoolStatus',
  DELETE_JOB_POOL_STATUS: 'deleteJobPoolStatus',
  GET_NEXT_STATUSES_BY_CURRENT: 'getNextStatusesByCurrentStatus',
  CREATE_NEXT_STATUS: 'createNextStatus',
  DELETE_NEXT_STATUS: 'deleteNextStatus',
}
